import { PluginObject } from 'vue';

export interface GtmEvent {
  event: string;
  category?: string;
  action?: string;
  label?: string;
  value?: string | number | null | boolean;
  noninteraction?: boolean;
}

export interface GtmMarked {
  gtm?: GtmEvent;
}

const getAnalyticsCookies = () => {
  const activityCookie = localStorage.getItem('cookie');
  return activityCookie?.includes('analytics_cookies');
};

export default {
  install(Vue) {
    Vue.prototype.$sendGtmEvent = (event: GtmEvent) => {
      const gtm = window.dataLayer || [];
      if (getAnalyticsCookies()) {
        gtm.push(event);
      }
    };
    Vue.prototype.$localStorageSet = (key: string, value: string) => {
      if (!key || !value) {
        return;
      }
      if (getAnalyticsCookies()) {
        localStorage.setItem(key, value);
      }
    };
  },
} as PluginObject<() => void>;
